"use client";

import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";

import { cn } from "./utils";
// function ScrollArea({
//   className,
//   children,
//   ...props
// }: React.ComponentProps<typeof ScrollAreaPrimitive.Root>) {
//   return (
//     <ScrollAreaPrimitive.Root
//       data-slot="scroll-area"
//       className={cn("relative", className)}
//       {...props}
//     >
//       <ScrollAreaPrimitive.Viewport
//         data-slot="scroll-area-viewport"
//         className="focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1"
//       >
//         {children}
//       </ScrollAreaPrimitive.Viewport>
//       <ScrollBar />
//       <ScrollAreaPrimitive.Corner />
//     </ScrollAreaPrimitive.Root>
//   );
// }

type ScrollAreaProps = React.ComponentProps<typeof ScrollAreaPrimitive.Root> & {
  syncRef?: React.RefObject<HTMLDivElement>;
  viewportRef?: React.RefObject<HTMLDivElement>;
  /** Total lines in this scrollArea */
  totalLines?: number;
  /** Total lines in the sync target scrollArea */
  syncTotalLines?: number;
  /** Fixed line height in px (default = 24 from your leading-6 h-6) */
  lineHeight?: number;
  showLineNumber?: boolean;
  ScrollAreaYAndXDirection?:boolean
};


function ScrollArea({
  className,
  children,
  viewportRef,
  syncRef,
  ScrollAreaYAndXDirection=false,
  ...props
}: ScrollAreaProps) {
  const localRef = React.useRef<HTMLDivElement | null>(null);

  const setViewportRef = (node: HTMLDivElement | null) => {
    localRef.current = node;
    if (viewportRef) viewportRef.current = node;
  };

  const handleScroll = () => {
    const src = localRef.current;
    const tgt = syncRef?.current;
    if (!src || !tgt) return;

    // avoid ping-pong
    if (tgt.dataset.syncing === "1") return;
    tgt.dataset.syncing = "1";

    tgt.scrollTo({
      top: src.scrollTop,
      left: src.scrollLeft,
      behavior: "auto",
    });

    requestAnimationFrame(() => {
      delete tgt.dataset.syncing;
    });
  };

  return (
    <ScrollAreaPrimitive.Root
      data-slot="scroll-area"
      className={cn("relative", className)}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport
        ref={setViewportRef}
        onScroll={handleScroll}
        data-slot="scroll-area-viewport"
        className="focus-visible:ring-ring/50 size-full rounded-[inherit] outline-none overflow-auto"
      >
        {children}
      </ScrollAreaPrimitive.Viewport>
      {ScrollAreaYAndXDirection?(
        <>
        <ScrollBar orientation="vertical" />
        <ScrollBar orientation="horizontal" />
        </>
      ):<ScrollBar />}
       
       {/* <ScrollBar orientation="horizontal"/> */}

      {/* vertical + horizontal scrollbars */}
      {/* <ScrollAreaPrimitive.Scrollbar orientation="vertical" />
      <ScrollAreaPrimitive.Scrollbar orientation="horizontal" /> */}
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
}



function ScrollBar({
  className,
  orientation = "vertical",
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>) {
  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      data-slot="scroll-area-scrollbar"
      orientation={orientation}
      className={cn(
        "flex touch-none p-px transition-colors select-none",
        orientation === "vertical" &&
          "h-full w-2.5 border-l border-l-transparent",
        orientation === "horizontal" &&
          "h-2.5 flex-col border-t border-t-transparent",
        className,
      )}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb
        data-slot="scroll-area-thumb"
        className="bg-border relative flex-1 rounded-full"
      />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  );
}

export { ScrollArea, ScrollBar };
